const PLATE_PATTERNS = [
    /^[A-Z]{2}\d{1,2}[A-Z]{0,3}\d{1,4}$/,
    /^\d{2}BH\d{4}[A-Z]{1,2}$/
]

export const MAX_PLATE_LENGTH = 12

export const normalizePlate = (value: string | null | undefined): string => (value ?? '')
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, MAX_PLATE_LENGTH)

export const formatPlate = (value: string | null | undefined): string => normalizePlate(value)
    .replace(/([A-Z])(?=\d)|(\d)(?=[A-Z])/g, '$1$2 ')

export const isStandardPlate = (value: string | null | undefined): boolean => {
    const plate = normalizePlate(value)
    return PLATE_PATTERNS.some(pattern => pattern.test(plate))
}

export const plateLabel = (plate: string | null | undefined, fallback = 'No number'): string => {
    const formatted = formatPlate(plate)
    return formatted || fallback
}

export const plateMatches = (plate: string, query: string): boolean => {
    const needle = normalizePlate(query)
    return !needle || normalizePlate(plate).includes(needle)
}
